export default __webpack_public_path__ + "static/media/wifi-3.63382603.svg";